import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { MenuItem } from '@mui/material';

import { fetchTypeaheadLicenseManufacturers, clearTypeahed } from '../../../actions';
import Typeahead from './Typeahead';
import TypeaheadSuggestion from './TypeaheadSuggestion';

function getSuggestionValue(suggestion) {
    return String(suggestion.name);
}

function renderSuggestion(suggestion, { query }) {
    return (
        <MenuItem component="div">
            <TypeaheadSuggestion
                value={suggestion.name}
                query={query}
            />
        </MenuItem>
    );
}

class SingleManufacturerTypeahead extends Component {
    static propTypes = {
        labelId: PropTypes.string,
        fetchTypeaheadLicenseManufacturers: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.string,
        renderSuggestion: PropTypes.func,
        getSuggestionValue: PropTypes.func,
    };

    static defaultProps = {
        labelId: 'licenseManufacturerName',
        suggestions: [],
        renderSuggestion,
        getSuggestionValue
    };

    handleSuggestionsFetchRequested = term => {
        this.props.fetchTypeaheadLicenseManufacturers(SingleManufacturerTypeahead.name, { term });
    };

    render() {
        return (
            <Typeahead
                error={this.props.error}
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onChangeSuggestion={this.props.onChangeSuggestion}
                t={this.props.t}
                {...this.props}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === SingleManufacturerTypeahead.name
            ? typeahead.list
            : SingleManufacturerTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchTypeaheadLicenseManufacturers,
    clearTypeahed
})(SingleManufacturerTypeahead);
